"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1410],{

/***/ 84363:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87537);
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":root{--color-scheme: light;--text-color: var(--slate);--background-color: var(--white);--slate: #081d34;--blue: #0057ff;--gray: #e6e6e6;--sky: #c4e0fd;--stone: #f1f1f1;--coral-light: #ffa19f;--violet-light: #96a4d8;--ice: #bff5f8;--tangerine-light: #fcc692;--sky-extra-light: #e4eefa;--coral: #ff645f;--violet: #4f66c2;--aqua: #47c7f0;--aqua-hover: var(--ice);--white: #ffffff;--tangerine: #fea143}:root{--color-scheme: light;--text-color: var(--mvp-slate);--background-color: var(--paper);--mvp-slate: #041527;--neutral-800: #223140;--neutral-700: #3f4c5a;--neutral-600: #5d6773;--neutral-500: #7a838c;--neutral-400: #989fa5;--neutral-300: #b6babe;--neutral-200: #d3d5d8;--neutral-100: #f1f1f1;--mvp-stone: #f1f1f1;--paper: #ffffff;--mvp-blue: #0057ff;--mvp-aqua: #00b4d8;--mvp-sky-100: #e1effe;--mvp-sky: #c4e0fd;--marigold-500: #f3b521;--marigold-200: #ffe3b2;--sand: #ffe3b2;--clay-600: #ce5a21;--clay-400: #ec9069;--clay-200: #f6c8b4;--mvp-coral: #ec9069;--aqua-800: #093e48;--aqua-100: #caf0f8;--aqua-200: #87dced;--deep-teal: #093e48;--light-teal: #caf0f8;--transparent: transparent;--ui-error-light: #fff0f4;--ui-error: #db0629;--ui-error-dark: #841531;--ui-success-light: #d7efdc;--ui-success: #1bb157;--ui-success-dark: #0f7134;--ui-warning-light: #feedaf;--ui-warning: #fbc916;--ui-warning-dark: #423200;--shadow-xs: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.25), 0 0 0.0625rem rgba(0, 0, 0, 0.16);--shadow-sm: 0 0.5rem 1rem rgba(0, 0, 0, 0.25), 0 0 0.0625rem rgba(0, 0, 0, 0.16);--shadow-md: 0 0.75rem 1.5rem rgba(0, 0, 0, 0.25), 0 0.0625rem 0.0625rem rgba(0, 0, 0, 0.16);--shadow-lg: 0 1.125rem 2.25rem rgba(0, 0, 0, 0.25), 0 0.0625rem 0.0625rem rgba(0, 0, 0, 0.16);--shadow-xl: 0 1.5rem 3rem rgba(0, 0, 0, 0.25), 0 0.0625rem 0.0625rem rgba(0, 0, 0, 0.16);--shadow-blue-xs: 0 0.125rem 0.5rem rgba(0, 87, 255, 0.25), 0 0 0.0625rem rgba(0, 87, 255, 0.16);--shadow-blue-sm: 0 0.5rem 1rem rgba(0, 87, 255, 0.25), 0 0 0.0625rem rgba(0, 87, 255, 0.16);--shadow-blue-md: 0 0.75rem 1.5rem rgba(0, 87, 255, 0.25), 0 0.0625rem 0.0625rem rgba(0, 87, 255, 0.16);--shadow-blue-lg: 0 1.125rem 2.25rem rgba(0, 87, 255, 0.25), 0 0.0625rem 0.0625rem rgba(0, 87, 255, 0.16);--shadow-blue-xl: 0 1.5rem 3rem rgba(0, 87, 255, 0.25), 0 0.0625rem 0.0625rem rgba(0, 87, 255, 0.16);--shadow-aqua-xs: 0 0.125rem 0.5rem rgba(2, 151, 180, 0.25), 0 0 0.0625rem rgba(2, 151, 180, 0.16);--shadow-aqua-sm: 0 0.5rem 1rem rgba(2, 151, 180, 0.25), 0 0 0.0625rem rgba(2, 151, 180, 0.16);--shadow-aqua-md: 0 0.75rem 1.5rem rgba(2, 151, 180, 0.25), 0 0.0625rem 0.0625rem rgba(2, 151, 180, 0.16);--shadow-aqua-lg: 0 1.125rem 2.25rem rgba(2, 151, 180, 0.25), 0 0.0625rem 0.0625rem rgba(2, 151, 180, 0.16);--shadow-aqua-xl: 0 1.5rem 3rem rgba(2, 151, 180, 0.25), 0 0.0625rem 0.0625rem rgba(2, 151, 180, 0.16);--shadow-marigold-xs: 0 0.125rem 0.5rem rgba(156, 112, 6, 0.25), 0 0 0.0625rem rgba(156, 112, 6, 0.16);--shadow-marigold-sm: 0 0.5rem 1rem rgba(156, 112, 6, 0.25), 0 0 0.0625rem rgba(156, 112, 6, 0.16);--shadow-marigold-md: 0 0.75rem 1.5rem rgba(156, 112, 6, 0.25), 0 0.0625rem 0.0625rem rgba(156, 112, 6, 0.16);--shadow-marigold-lg: 0 1.125rem 2.25rem rgba(156, 112, 6, 0.25), 0 0.0625rem 0.0625rem rgba(156, 112, 6, 0.16);--shadow-marigold-xl: 0 1.5rem 3rem rgba(156, 112, 6, 0.25), 0 0.0625rem 0.0625rem rgba(156, 112, 6, 0.16);--shadow-clay-xs: 0 0.125rem 0.5rem rgba(206, 90, 33, 0.25), 0 0 0.0625rem rgba(206, 90, 33, 0.16);--shadow-clay-sm: 0 0.5rem 1rem rgba(206, 90, 33, 0.25), 0 0 0.0625rem rgba(206, 90, 33, 0.16);--shadow-clay-md: 0 0.75rem 1.5rem rgba(206, 90, 33, 0.25), 0 0.0625rem 0.0625rem rgba(206, 90, 33, 0.16);--shadow-clay-lg: 0 1.125rem 2.25rem rgba(206, 90, 33, 0.25), 0 0.0625rem 0.0625rem rgba(206, 90, 33, 0.16);--shadow-clay-xl: 0 1.5rem 3rem rgba(206, 90, 33, 0.25), 0 0.0625rem 0.0625rem rgba(206, 90, 33, 0.16);--fin-black: #000000;--fin-white: #ffffff;--fin-blue: #0057ff;--fin-error: #841531}.pre-footer--s4MmB.pre-footer__inset--Ff1pK{max-width:77.5rem;padding-left:2rem;padding-right:2rem;margin-left:1.25rem;margin-right:1.25rem;border-radius:1.5rem}.pre-footer--s4MmB.pre-footer__fullWidth--gNpkM{max-width:\"unset\";padding-left:1.25rem;padding-right:1.25rem;margin-left:0;margin-right:0;border-radius:0}.pre-footer--s4MmB>div.pre-footer__inner--vBpmZ{row-gap:2rem;align-items:center}.pre-footer__content--O_us_{text-align:center;grid-column:1/-1}.pre-footer__eyebrow--heS06{margin-bottom:1rem}.pre-footer__subhead--kjobo{margin-top:1rem}.pre-footer__link-text--Ld8dh{margin-top:1.5rem}.pre-footer__ctas--d_awS{grid-column:1/-1;display:flex;flex-direction:column}.pre-footer__ctas__multi-cta-gap--vd9yy{gap:.75rem}.pre-footer__ctas__single-cta-gap--xarlL{gap:1rem}.pre-footer__ctas--d_awS input.email-form__input{box-shadow:inset 0 0 0 2px var(--neutral-200)}.pre-footer__ctas--d_awS form.email-form--flex-column .email-form__submit{margin-block-start:.5rem}.pre-footer__ctas--d_awS .ul-list--checkmarks{display:flex;flex-wrap:wrap;justify-content:center;column-gap:1.5rem;row-gap:.5rem}.pre-footer__ctas--d_awS .ul-list--checkmarks li{margin-bottom:0;align-items:center}.pre-footer__ctas--d_awS .ul-list--checkmarks li svg{margin-top:0}.pre-footer__checkmarks--MJ7PZ{width:100%}.pre-footer__checkmarks--MJ7PZ .rich-text ul,.pre-footer__checkmarks--MJ7PZ .rich-text span,.pre-footer__checkmarks--MJ7PZ .rich-text p{font-size:inherit}@media(min-width: 768px){.pre-footer--s4MmB.pre-footer__inset--Ff1pK{padding-left:0;padding-right:0}.pre-footer--s4MmB.pre-footer__fullWidth--gNpkM{padding-left:\"1.25rem\";padding-right:\"1.25rem\"}.pre-footer--s4MmB>div.pre-footer__inner--vBpmZ{row-gap:2.5rem}.pre-footer__content--O_us_{grid-column:2/-2}.pre-footer__eyebrow--heS06{margin-bottom:1.25rem}.pre-footer__ctas--d_awS{grid-column:2/-2;justify-content:center}.pre-footer__ctas__flex-row--lOXQ6{flex-direction:row}.pre-footer__ctas__flex-column--r_OQH{flex-direction:column}.pre-footer__ctas--d_awS .ul-list--checkmarks li:last-child{margin-top:0}}@media(min-width: 1024px){.pre-footer--s4MmB>div.pre-footer__inner--vBpmZ{display:flex;justify-content:center}.pre-footer__content--O_us_{max-width:calc((100% - 22rem)/12*6 + 10rem);margin-left:calc((100% - 22rem)/12 + 2rem);text-align:start}.pre-footer__ctas--d_awS{margin-right:calc((100% - 22rem)/12 + 2rem)}}@media(min-width: 77.5em){.pre-footer--s4MmB.pre-footer__inset--Ff1pK{margin-left:auto;margin-right:auto}.pre-footer__ctas--d_awS>form.email-form{width:28.75rem}}", "",{"version":3,"sources":["webpack://./src/library/styles/abstracts/_color-schemes.scss","webpack://./src/library/styles/abstracts-mvp/_color-schemes.scss","webpack://./src/sass-components/library/components/PreFooterCTABlock/styles.module.scss","webpack://./src/library/styles/abstracts/_constants.scss"],"names":[],"mappings":"AAAA,MACE,qBAAA,CACA,0BAAA,CACA,gCAAA,CAGA,gBAAA,CACA,eAAA,CACA,eAAA,CACA,cAAA,CACA,gBAAA,CACA,sBAAA,CACA,uBAAA,CACA,cAAA,CACA,0BAAA,CACA,0BAAA,CACA,gBAAA,CACA,iBAAA,CACA,eAAA,CACA,wBAAA,CACA,gBAAA,CACA,oBAAA,CCrBF,MACE,qBAAA,CACA,8BAAA,CACA,gCAAA,CAGA,oBAAA,CACA,sBAAA,CACA,sBAAA,CACA,sBAAA,CACA,sBAAA,CACA,sBAAA,CACA,sBAAA,CACA,sBAAA,CACA,sBAAA,CACA,oBAAA,CACA,gBAAA,CACA,mBAAA,CACA,mBAAA,CACA,sBAAA,CACA,kBAAA,CACA,uBAAA,CACA,uBAAA,CACA,eAAA,CACA,mBAAA,CACA,mBAAA,CACA,mBAAA,CACA,oBAAA,CACA,mBAAA,CACA,mBAAA,CACA,mBAAA,CACA,oBAAA,CACA,qBAAA,CACA,0BAAA,CACA,yBAAA,CACA,mBAAA,CACA,wBAAA,CACA,2BAAA,CACA,qBAAA,CACA,0BAAA,CACA,2BAAA,CACA,qBAAA,CACA,0BAAA,CAGA,qFAAA,CACA,iFAAA,CACA,4FAAA,CACA,8FAAA,CACA,yFAAA,CAEA,gGAAA,CACA,4FAAA,CACA,uGAAA,CAEA,yGAAA,CAEA,oGAAA,CAGA,kGAAA,CACA,8FAAA,CACA,yGAAA,CAEA,2GAAA,CAEA,sGAAA,CAGA,sGAAA,CAEA,kGAAA,CACA,6GAAA,CAEA,+GAAA,CAEA,0GAAA,CAGA,kGAAA,CACA,8FAAA,CACA,yGAAA,CAEA,2GAAA,CAEA,sGAAA,CAIA,oBAAA,CACA,oBAAA,CACA,mBAAA,CACA,oBAAA,CCzFA,4CACE,iBAAA,CACA,iBAAA,CACA,kBAAA,CACA,mBAAA,CACA,oBAAA,CACA,oBAAA,CAGF,gDACE,iBAAA,CACA,oBAAA,CACA,qBAAA,CACA,aAAA,CACA,cAAA,CACA,eAAA,CAGF,gDACE,YAAA,CACA,kBAAA,CAGF,4BACE,iBAAA,CACA,gBAAA,CAGF,4BACE,kBAAA,CAGF,4BACE,eAAA,CAGF,8BACE,iBAAA,CAGF,yBACE,gBAAA,CACA,YAAA,CACA,qBAAA,CAEA,wCACE,UAAA,CAGF,yCACE,QAAA,CAGF,iDACE,6CAAA,CAGF,0EACE,wBAAA,CAGF,8CACE,YAAA,CACA,cAAA,CACA,sBAAA,CACA,iBAAA,CACA,aAAA,CAEA,iDACE,eAAA,CACA,kBAAA,CAEA,qDACE,YAAA,CAMR,+BACE,UAAA,CAEA,wIAGE,iBAAA,CC5EJ,yBDmFE,4CACE,cAAA,CACA,eAAA,CAEF,gDACE,sBAAA,CACA,uBAAA,CAGF,gDACE,cAAA,CAGF,4BACE,gBAAA,CAGF,4BACE,qBAAA,CAGF,yBACE,gBAAA,CAUA,sBAAA,CARA,mCACE,kBAAA,CAGF,sCACE,qBAAA,CAMA,4DACE,YAAA,CAAA,CCvHR,0BDgIE,gDACE,YAAA,CACA,sBAAA,CAGF,4BACE,2CAAA,CACA,0CAAA,CACA,gBAAA,CAGF,yBACE,2CAAA,CAAA,CAKN,0BAEI,4CACE,gBAAA,CACA,iBAAA,CAIA,yCACE,cAAA,CAAA","sourcesContent":[":root {\n  --color-scheme: light;\n  --text-color: var(--slate);\n  --background-color: var(--white);\n\n  // Color palette\n  --slate: #081d34;\n  --blue: #0057ff;\n  --gray: #e6e6e6;\n  --sky: #c4e0fd;\n  --stone: #f1f1f1;\n  --coral-light: #ffa19f;\n  --violet-light: #96a4d8;\n  --ice: #bff5f8;\n  --tangerine-light: #fcc692;\n  --sky-extra-light: #e4eefa;\n  --coral: #ff645f;\n  --violet: #4f66c2;\n  --aqua: #47c7f0;\n  --aqua-hover: var(--ice);\n  --white: #ffffff;\n  --tangerine: #fea143;\n}\n",":root {\n  --color-scheme: light;\n  --text-color: var(--mvp-slate);\n  --background-color: var(--paper);\n\n  // Color palette\n  --mvp-slate: #041527;\n  --neutral-800: #223140;\n  --neutral-700: #3f4c5a;\n  --neutral-600: #5d6773;\n  --neutral-500: #7a838c;\n  --neutral-400: #989fa5;\n  --neutral-300: #b6babe;\n  --neutral-200: #d3d5d8;\n  --neutral-100: #f1f1f1;\n  --mvp-stone: #f1f1f1;\n  --paper: #ffffff;\n  --mvp-blue: #0057ff;\n  --mvp-aqua: #00b4d8;\n  --mvp-sky-100: #e1effe;\n  --mvp-sky: #c4e0fd;\n  --marigold-500: #f3b521;\n  --marigold-200: #ffe3b2;\n  --sand: #ffe3b2;\n  --clay-600: #ce5a21;\n  --clay-400: #ec9069;\n  --clay-200: #f6c8b4;\n  --mvp-coral: #ec9069;\n  --aqua-800: #093e48;\n  --aqua-100: #caf0f8;\n  --aqua-200: #87dced;\n  --deep-teal: #093e48;\n  --light-teal: #caf0f8;\n  --transparent: transparent;\n  --ui-error-light: #fff0f4;\n  --ui-error: #db0629;\n  --ui-error-dark: #841531;\n  --ui-success-light: #d7efdc;\n  --ui-success: #1bb157;\n  --ui-success-dark: #0f7134;\n  --ui-warning-light: #feedaf;\n  --ui-warning: #fbc916;\n  --ui-warning-dark: #423200;\n\n  // Fin Shadows\n  --shadow-xs: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.25), 0 0 0.0625rem rgba(0, 0, 0, 0.16);\n  --shadow-sm: 0 0.5rem 1rem rgba(0, 0, 0, 0.25), 0 0 0.0625rem rgba(0, 0, 0, 0.16);\n  --shadow-md: 0 0.75rem 1.5rem rgba(0, 0, 0, 0.25), 0 0.0625rem 0.0625rem rgba(0, 0, 0, 0.16);\n  --shadow-lg: 0 1.125rem 2.25rem rgba(0, 0, 0, 0.25), 0 0.0625rem 0.0625rem rgba(0, 0, 0, 0.16);\n  --shadow-xl: 0 1.5rem 3rem rgba(0, 0, 0, 0.25), 0 0.0625rem 0.0625rem rgba(0, 0, 0, 0.16);\n\n  --shadow-blue-xs: 0 0.125rem 0.5rem rgba(0, 87, 255, 0.25), 0 0 0.0625rem rgba(0, 87, 255, 0.16);\n  --shadow-blue-sm: 0 0.5rem 1rem rgba(0, 87, 255, 0.25), 0 0 0.0625rem rgba(0, 87, 255, 0.16);\n  --shadow-blue-md: 0 0.75rem 1.5rem rgba(0, 87, 255, 0.25),\n    0 0.0625rem 0.0625rem rgba(0, 87, 255, 0.16);\n  --shadow-blue-lg: 0 1.125rem 2.25rem rgba(0, 87, 255, 0.25),\n    0 0.0625rem 0.0625rem rgba(0, 87, 255, 0.16);\n  --shadow-blue-xl: 0 1.5rem 3rem rgba(0, 87, 255, 0.25),\n    0 0.0625rem 0.0625rem rgba(0, 87, 255, 0.16);\n\n  --shadow-aqua-xs: 0 0.125rem 0.5rem rgba(2, 151, 180, 0.25), 0 0 0.0625rem rgba(2, 151, 180, 0.16);\n  --shadow-aqua-sm: 0 0.5rem 1rem rgba(2, 151, 180, 0.25), 0 0 0.0625rem rgba(2, 151, 180, 0.16);\n  --shadow-aqua-md: 0 0.75rem 1.5rem rgba(2, 151, 180, 0.25),\n    0 0.0625rem 0.0625rem rgba(2, 151, 180, 0.16);\n  --shadow-aqua-lg: 0 1.125rem 2.25rem rgba(2, 151, 180, 0.25),\n    0 0.0625rem 0.0625rem rgba(2, 151, 180, 0.16);\n  --shadow-aqua-xl: 0 1.5rem 3rem rgba(2, 151, 180, 0.25),\n    0 0.0625rem 0.0625rem rgba(2, 151, 180, 0.16);\n\n  --shadow-marigold-xs: 0 0.125rem 0.5rem rgba(156, 112, 6, 0.25),\n    0 0 0.0625rem rgba(156, 112, 6, 0.16);\n  --shadow-marigold-sm: 0 0.5rem 1rem rgba(156, 112, 6, 0.25), 0 0 0.0625rem rgba(156, 112, 6, 0.16);\n  --shadow-marigold-md: 0 0.75rem 1.5rem rgba(156, 112, 6, 0.25),\n    0 0.0625rem 0.0625rem rgba(156, 112, 6, 0.16);\n  --shadow-marigold-lg: 0 1.125rem 2.25rem rgba(156, 112, 6, 0.25),\n    0 0.0625rem 0.0625rem rgba(156, 112, 6, 0.16);\n  --shadow-marigold-xl: 0 1.5rem 3rem rgba(156, 112, 6, 0.25),\n    0 0.0625rem 0.0625rem rgba(156, 112, 6, 0.16);\n\n  --shadow-clay-xs: 0 0.125rem 0.5rem rgba(206, 90, 33, 0.25), 0 0 0.0625rem rgba(206, 90, 33, 0.16);\n  --shadow-clay-sm: 0 0.5rem 1rem rgba(206, 90, 33, 0.25), 0 0 0.0625rem rgba(206, 90, 33, 0.16);\n  --shadow-clay-md: 0 0.75rem 1.5rem rgba(206, 90, 33, 0.25),\n    0 0.0625rem 0.0625rem rgba(206, 90, 33, 0.16);\n  --shadow-clay-lg: 0 1.125rem 2.25rem rgba(206, 90, 33, 0.25),\n    0 0.0625rem 0.0625rem rgba(206, 90, 33, 0.16);\n  --shadow-clay-xl: 0 1.5rem 3rem rgba(206, 90, 33, 0.25),\n    0 0.0625rem 0.0625rem rgba(206, 90, 33, 0.16);\n\n  // Fin palette\n  --fin-black: #000000;\n  --fin-white: #ffffff;\n  --fin-blue: #0057ff;\n  --fin-error: #841531;\n}\n","@import '/src/library/styles/main';\n\n.pre-footer {\n  &.pre-footer__inset {\n    max-width: 77.5rem;\n    padding-left: 2rem;\n    padding-right: 2rem;\n    margin-left: 1.25rem;\n    margin-right: 1.25rem;\n    border-radius: 1.5rem;\n  }\n\n  &.pre-footer__fullWidth {\n    max-width: 'unset';\n    padding-left: 1.25rem;\n    padding-right: 1.25rem;\n    margin-left: 0;\n    margin-right: 0;\n    border-radius: 0;\n  }\n\n  > div.pre-footer__inner {\n    row-gap: 2rem;\n    align-items: center;\n  }\n\n  &__content {\n    text-align: center;\n    grid-column: 1/-1;\n  }\n\n  &__eyebrow {\n    margin-bottom: 1rem;\n  }\n\n  &__subhead {\n    margin-top: 1rem;\n  }\n\n  &__link-text {\n    margin-top: 1.5rem;\n  }\n\n  &__ctas {\n    grid-column: 1/-1;\n    display: flex;\n    flex-direction: column;\n\n    &__multi-cta-gap {\n      gap: 0.75rem;\n    }\n\n    &__single-cta-gap {\n      gap: 1rem;\n    }\n\n    :global(input.email-form__input) {\n      box-shadow: inset 0 0 0 2px var(--neutral-200);\n    }\n\n    :global(form.email-form--flex-column .email-form__submit) {\n      margin-block-start: 0.5rem;\n    }\n\n    :global(.ul-list--checkmarks) {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: center;\n      column-gap: 1.5rem;\n      row-gap: 0.5rem;\n\n      :global(li) {\n        margin-bottom: 0;\n        align-items: center;\n\n        :global(svg) {\n          margin-top: 0;\n        }\n      }\n    }\n  }\n\n  &__checkmarks {\n    width: 100%;\n\n    :global(.rich-text ul),\n    :global(.rich-text span),\n    :global(.rich-text p) {\n      font-size: inherit;\n    }\n  }\n}\n\n@include media-query(tablet) {\n  .pre-footer {\n    &.pre-footer__inset {\n      padding-left: 0;\n      padding-right: 0;\n    }\n    &.pre-footer__fullWidth {\n      padding-left: '1.25rem';\n      padding-right: '1.25rem';\n    }\n\n    > div.pre-footer__inner {\n      row-gap: 2.5rem;\n    }\n\n    &__content {\n      grid-column: 2/-2;\n    }\n\n    &__eyebrow {\n      margin-bottom: 1.25rem;\n    }\n\n    &__ctas {\n      grid-column: 2/-2;\n\n      &__flex-row {\n        flex-direction: row;\n      }\n\n      &__flex-column {\n        flex-direction: column;\n      }\n\n      justify-content: center;\n\n      :global(.ul-list--checkmarks) {\n        :global(li:last-child) {\n          margin-top: 0;\n        }\n      }\n    }\n  }\n}\n\n@include media-query(desktop) {\n  .pre-footer {\n    > div.pre-footer__inner {\n      display: flex;\n      justify-content: center;\n    }\n\n    &__content {\n      max-width: calc((100% - 2rem * 11) / 12 * 6 + 2rem * 5);\n      margin-left: calc((100% - 2rem * 11) / 12 + 2rem);\n      text-align: start;\n    }\n\n    &__ctas {\n      margin-right: calc((100% - 2rem * 11) / 12 + 2rem);\n    }\n  }\n}\n\n@media (min-width: 77.5em) {\n  .pre-footer {\n    &.pre-footer__inset {\n      margin-left: auto;\n      margin-right: auto;\n    }\n\n    &__ctas {\n      > :global(form.email-form) {\n        width: 28.75rem;\n      }\n    }\n  }\n}\n","// Media Queries\n$media-query: (\n  mobile: 'max-width: 767px',\n  tablet: 'min-width: 768px',\n  laptop: 'min-width: 990px',\n  desktop: 'min-width: 1024px',\n  desktopMid: 'min-width: 1280px',\n  desktopLg: 'min-width: 1440px',\n);\n\n@mixin media-query($size) {\n  $get-media-query: map-get($media-query, $size);\n  @media ($get-media-query) {\n    @content;\n  }\n}\n\n// Layout Variables\n$container-max-width: 1290px;\n$company-logo-max-height: 28px;\n$company-logo-max-width: 125px;\n$menu-min-width: 275px;\n$icon-width: 60px;\n$viewport-max-width: 1440px;\n\n$grid-gap-map: (\n  mobile: 8px,\n  tablet: 16px,\n  desktop: 24px,\n);\n\n// Timing\n$timing-superfast: 100ms;\n$timing-fast: 250ms;\n$timing-standard: 500ms;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pre-footer": "pre-footer--s4MmB",
	"pre-footer__inset": "pre-footer__inset--Ff1pK",
	"pre-footer__fullWidth": "pre-footer__fullWidth--gNpkM",
	"pre-footer__inner": "pre-footer__inner--vBpmZ",
	"pre-footer__content": "pre-footer__content--O_us_",
	"pre-footer__eyebrow": "pre-footer__eyebrow--heS06",
	"pre-footer__subhead": "pre-footer__subhead--kjobo",
	"pre-footer__link-text": "pre-footer__link-text--Ld8dh",
	"pre-footer__ctas": "pre-footer__ctas--d_awS",
	"pre-footer__ctas__multi-cta-gap": "pre-footer__ctas__multi-cta-gap--vd9yy",
	"pre-footer__ctas__single-cta-gap": "pre-footer__ctas__single-cta-gap--xarlL",
	"pre-footer__checkmarks": "pre-footer__checkmarks--MJ7PZ",
	"pre-footer__ctas__flex-row": "pre-footer__ctas__flex-row--lOXQ6",
	"pre-footer__ctas__flex-column": "pre-footer__ctas__flex-column--r_OQH"
};
/* harmony default export */ __webpack_exports__["Z"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 91878:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* reexport */ SignUpCTA; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(17563);
// EXTERNAL MODULE: ./lib/page-behaviors/EarlyStage.tsx
var EarlyStage = __webpack_require__(32);
// EXTERNAL MODULE: ./lib/sentry.js
var sentry = __webpack_require__(98903);
// EXTERNAL MODULE: ./lib/teammateAppUrl.ts
var teammateAppUrl = __webpack_require__(64314);
// EXTERNAL MODULE: ./src/components/context/MarketoFormsContext.tsx
var MarketoFormsContext = __webpack_require__(96975);
// EXTERNAL MODULE: ./src/components/context/SignupCTAOverridePropsContext.tsx
var SignupCTAOverridePropsContext = __webpack_require__(90573);
// EXTERNAL MODULE: ./src/components/context/SignupCTAParamsContext.tsx
var SignupCTAParamsContext = __webpack_require__(55015);
// EXTERNAL MODULE: ./src/sass-components/library/elements/CTALink/index.ts + 3 modules
var CTALink = __webpack_require__(88511);
// EXTERNAL MODULE: ./src/mvp/library/utils/index.ts
var utils = __webpack_require__(58672);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(95627);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-uid/dist/es2015/hooks.js + 2 modules
var hooks = __webpack_require__(34699);
// EXTERNAL MODULE: ./lib/gtm.ts
var gtm = __webpack_require__(75917);
// EXTERNAL MODULE: ./lib/validEmail.ts
var validEmail = __webpack_require__(88227);
// EXTERNAL MODULE: ./src/library/utils/index.ts + 15 modules
var library_utils = __webpack_require__(20137);
// EXTERNAL MODULE: ./src/library/elements/LoadingAnimation/index.ts + 1 modules
var LoadingAnimation = __webpack_require__(48487);
// EXTERNAL MODULE: ./src/library/elements/Text/index.ts + 6 modules
var Text = __webpack_require__(36751);
// EXTERNAL MODULE: ./src/library/elements/VisuallyHidden/index.ts + 1 modules
var VisuallyHidden = __webpack_require__(4164);
// EXTERNAL MODULE: ./src/library/hooks/useIosInputScrollEvents/index.ts + 1 modules
var useIosInputScrollEvents = __webpack_require__(15411);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/mvp/library/elements/EmailForm/element.tsx
















var EmailForm = function EmailForm(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'large' : _ref$size,
      buttonText = _ref.buttonText,
      validity = _ref.validity,
      placeholderText = _ref.placeholderText,
      value = _ref.value,
      small = _ref.small,
      onChange = _ref.onChange,
      onSubmit = _ref.onSubmit,
      passedInputRef = _ref.inputRef,
      loading = _ref.loading,
      onFormFocus = _ref.onFormFocus;

  var _useContext = (0,react.useContext)(library_utils.CurrentUILocaleContext),
      ui = _useContext.ui;

  var selfRef = (0,react.useRef)(null);

  var _useIOsInputScrollEve = (0,useIosInputScrollEvents/* useIOsInputScrollEvents */.u)(),
      iosOnFocus = _useIOsInputScrollEve.iosOnFocus,
      iosOnBlur = _useIOsInputScrollEve.iosOnBlur;

  var componentId = (0,hooks/* useUID */.D)();
  var inputElementId = "email_".concat(componentId);
  var errorElementId = "signup-cta-error_".concat(componentId);
  var inputRef = passedInputRef || /*#__PURE__*/(0,react.createRef)();

  function handleChange(event) {
    onChange(event.target.value);
  }

  function handleFocus() {
    iosOnFocus();

    if (onFormFocus) {
      onFormFocus();
    }
  }

  function handleSubmit(event) {
    event.preventDefault();
    onSubmit(event);
  }

  var classes = classnames_default()('email-form', {
    'email-form--small': small,
    'email-form--loading': loading,
    'email-form--error': !validity.isValid
  });
  var submitButtonClasses = classnames_default()('email-form__submit-button', ' email-form__submit-button--blue-fill', {
    'email-form__submit-button--small': size === 'small'
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
    ref: selfRef,
    onSubmit: handleSubmit,
    noValidate: true,
    className: style_default().dynamic([["2337661506", [size === 'large' ? '3rem' : '2.5rem', size === 'large' ? '0.5rem 1rem' : '0.25rem 0.75rem', library_utils.mq.tablet]]]) + " " + (classes || ""),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(VisuallyHidden/* VisuallyHidden */.T, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
        htmlFor: inputElementId,
        className: style_default().dynamic([["2337661506", [size === 'large' ? '3rem' : '2.5rem', size === 'large' ? '0.5rem 1rem' : '0.25rem 0.75rem', library_utils.mq.tablet]]]),
        children: placeholderText || ui.localize('EmailForm.defaultEmailFieldPlaceholder')
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: style_default().dynamic([["2337661506", [size === 'large' ? '3rem' : '2.5rem', size === 'large' ? '0.5rem 1rem' : '0.25rem 0.75rem', library_utils.mq.tablet]]]) + " " + "email-form__field",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
        type: "email",
        id: inputElementId,
        value: value,
        onFocus: handleFocus,
        onBlur: iosOnBlur,
        onChange: handleChange,
        autoCapitalize: "none",
        autoCorrect: "off",
        spellCheck: false,
        "aria-required": "true",
        "aria-invalid": !validity.isValid,
        "aria-describedby": errorElementId,
        ref: inputRef,
        placeholder: placeholderText || ui.localize('EmailForm.defaultEmailFieldPlaceholder'),
        "data-testid": "email-form-input",
        className: style_default().dynamic([["2337661506", [size === 'large' ? '3rem' : '2.5rem', size === 'large' ? '0.5rem 1rem' : '0.25rem 0.75rem', library_utils.mq.tablet]]]) + " " + "email-form__input"
      }), !validity.isValid && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        id: errorElementId,
        "data-testid": "error",
        className: style_default().dynamic([["2337661506", [size === 'large' ? '3rem' : '2.5rem', size === 'large' ? '0.5rem 1rem' : '0.25rem 0.75rem', library_utils.mq.tablet]]]) + " " + "email-form__error-message",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.xv, {
          size: "caption",
          children: validity.errorText
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
        type: "submit",
        "data-testid": "submit",
        className: style_default().dynamic([["2337661506", [size === 'large' ? '3rem' : '2.5rem', size === 'large' ? '0.5rem 1rem' : '0.25rem 0.75rem', library_utils.mq.tablet]]]) + " " + (submitButtonClasses || ""),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.xv, {
          size: "body-bold",
          children: buttonText
        }), loading && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: style_default().dynamic([["2337661506", [size === 'large' ? '3rem' : '2.5rem', size === 'large' ? '0.5rem 1rem' : '0.25rem 0.75rem', library_utils.mq.tablet]]]) + " " + "email-form__submit__loading-indicator",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(LoadingAnimation/* LoadingAnimation */.p, {})
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((style_default()), {
      id: "2337661506",
      dynamic: [size === 'large' ? '3rem' : '2.5rem', size === 'large' ? '0.5rem 1rem' : '0.25rem 0.75rem', library_utils.mq.tablet],
      children: [".__jsx-style-dynamic-selector:root{--color-scheme:light;--text-color:var(--slate);--background-color:var(--white);--slate:#081d34;--blue:#0057ff;--gray:#e6e6e6;--sky:#c4e0fd;--stone:#f1f1f1;--coral-light:#ffa19f;--violet-light:#96a4d8;--ice:#bff5f8;--tangerine-light:#fcc692;--sky-extra-light:#e4eefa;--coral:#ff645f;--violet:#4f66c2;--aqua:#47c7f0;--aqua-hover:var(--ice);--white:#ffffff;--tangerine:#fea143;}", ".__jsx-style-dynamic-selector:root{--color-scheme:light;--text-color:var(--mvp-slate);--background-color:var(--paper);--mvp-slate:#041527;--neutral-800:#223140;--neutral-700:#3f4c5a;--neutral-600:#5d6773;--neutral-500:#7a838c;--neutral-400:#989fa5;--neutral-300:#b6babe;--neutral-200:#d3d5d8;--neutral-100:#f1f1f1;--mvp-stone:#f1f1f1;--paper:#ffffff;--mvp-blue:#0057ff;--mvp-aqua:#00b4d8;--mvp-sky-100:#e1effe;--mvp-sky:#c4e0fd;--marigold-500:#f3b521;--marigold-200:#ffe3b2;--sand:#ffe3b2;--clay-600:#ce5a21;--clay-400:#ec9069;--clay-200:#f6c8b4;--mvp-coral:#ec9069;--aqua-800:#093e48;--aqua-100:#caf0f8;--aqua-200:#87dced;--deep-teal:#093e48;--light-teal:#caf0f8;--transparent:transparent;--ui-error-light:#fff0f4;--ui-error:#db0629;--ui-error-dark:#841531;--ui-success-light:#d7efdc;--ui-success:#1bb157;--ui-success-dark:#0f7134;--ui-warning-light:#feedaf;--ui-warning:#fbc916;--ui-warning-dark:#423200;--shadow-xs:0 0.125rem 0.5rem rgba(0,0,0,0.25),0 0 0.0625rem rgba(0,0,0,0.16);--shadow-sm:0 0.5rem 1rem rgba(0,0,0,0.25),0 0 0.0625rem rgba(0,0,0,0.16);--shadow-md:0 0.75rem 1.5rem rgba(0,0,0,0.25),0 0.0625rem 0.0625rem rgba(0,0,0,0.16);--shadow-lg:0 1.125rem 2.25rem rgba(0,0,0,0.25),0 0.0625rem 0.0625rem rgba(0,0,0,0.16);--shadow-xl:0 1.5rem 3rem rgba(0,0,0,0.25),0 0.0625rem 0.0625rem rgba(0,0,0,0.16);--shadow-blue-xs:0 0.125rem 0.5rem rgba(0,87,255,0.25),0 0 0.0625rem rgba(0,87,255,0.16);--shadow-blue-sm:0 0.5rem 1rem rgba(0,87,255,0.25),0 0 0.0625rem rgba(0,87,255,0.16);--shadow-blue-md:0 0.75rem 1.5rem rgba(0,87,255,0.25), 0 0.0625rem 0.0625rem rgba(0,87,255,0.16);--shadow-blue-lg:0 1.125rem 2.25rem rgba(0,87,255,0.25), 0 0.0625rem 0.0625rem rgba(0,87,255,0.16);--shadow-blue-xl:0 1.5rem 3rem rgba(0,87,255,0.25), 0 0.0625rem 0.0625rem rgba(0,87,255,0.16);--shadow-aqua-xs:0 0.125rem 0.5rem rgba(2,151,180,0.25),0 0 0.0625rem rgba(2,151,180,0.16);--shadow-aqua-sm:0 0.5rem 1rem rgba(2,151,180,0.25),0 0 0.0625rem rgba(2,151,180,0.16);--shadow-aqua-md:0 0.75rem 1.5rem rgba(2,151,180,0.25), 0 0.0625rem 0.0625rem rgba(2,151,180,0.16);--shadow-aqua-lg:0 1.125rem 2.25rem rgba(2,151,180,0.25), 0 0.0625rem 0.0625rem rgba(2,151,180,0.16);--shadow-aqua-xl:0 1.5rem 3rem rgba(2,151,180,0.25), 0 0.0625rem 0.0625rem rgba(2,151,180,0.16);--shadow-marigold-xs:0 0.125rem 0.5rem rgba(156,112,6,0.25), 0 0 0.0625rem rgba(156,112,6,0.16);--shadow-marigold-sm:0 0.5rem 1rem rgba(156,112,6,0.25),0 0 0.0625rem rgba(156,112,6,0.16);--shadow-marigold-md:0 0.75rem 1.5rem rgba(156,112,6,0.25), 0 0.0625rem 0.0625rem rgba(156,112,6,0.16);--shadow-marigold-lg:0 1.125rem 2.25rem rgba(156,112,6,0.25), 0 0.0625rem 0.0625rem rgba(156,112,6,0.16);--shadow-marigold-xl:0 1.5rem 3rem rgba(156,112,6,0.25), 0 0.0625rem 0.0625rem rgba(156,112,6,0.16);--shadow-clay-xs:0 0.125rem 0.5rem rgba(206,90,33,0.25),0 0 0.0625rem rgba(206,90,33,0.16);--shadow-clay-sm:0 0.5rem 1rem rgba(206,90,33,0.25),0 0 0.0625rem rgba(206,90,33,0.16);--shadow-clay-md:0 0.75rem 1.5rem rgba(206,90,33,0.25), 0 0.0625rem 0.0625rem rgba(206,90,33,0.16);--shadow-clay-lg:0 1.125rem 2.25rem rgba(206,90,33,0.25), 0 0.0625rem 0.0625rem rgba(206,90,33,0.16);--shadow-clay-xl:0 1.5rem 3rem rgba(206,90,33,0.25), 0 0.0625rem 0.0625rem rgba(206,90,33,0.16);--fin-black:#000000;--fin-white:#ffffff;--fin-blue:#0057ff;--fin-error:#841531;}", ".email-form.__jsx-style-dynamic-selector{width:100%;max-width:50rem;margin:0 auto;position:relative;}", ".email-form--error.__jsx-style-dynamic-selector .email-form__input.__jsx-style-dynamic-selector{box-shadow:inset 0 0 0 2px var(--ui-error);}", ".email-form--error.__jsx-style-dynamic-selector .email-form__input.__jsx-style-dynamic-selector:focus,.email-form--error.__jsx-style-dynamic-selector .email-form__input.__jsx-style-dynamic-selector:focus-within{box-shadow:inset 0 0 0 2px var(--mvp-blue);}", ".email-form__field.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-align-content:center;-ms-flex-line-pack:center;align-content:center;}", ".email-form__input.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:100%;height:".concat(size === 'large' ? '3rem' : '2.5rem', ";padding:0 1.125rem;border-radius:1.5rem;background-color:var(--paper);box-shadow:inset 0 0 0 2px var(--mvp-slate);font:inherit;color:var(--mvp-slate);-webkit-transition:box-shadow 0.24s;transition:box-shadow 0.24s;-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;outline:none;resize:none;}"), ".email-form__input.__jsx-style-dynamic-selector:focus,.email-form__input.__jsx-style-dynamic-selector:focus-within{box-shadow:inset 0 0 0 2px var(--mvp-blue);}", ".email-form__input.__jsx-style-dynamic-selector:disabled{opacity:0.5;cursor:not-allowed;}", ".email-form__input.__jsx-style-dynamic-selector::-webkit-input-placeholder{color:var(--neutral-500);}", ".email-form__input.__jsx-style-dynamic-selector::-moz-placeholder{color:var(--neutral-500);}", ".email-form__input.__jsx-style-dynamic-selector:-ms-input-placeholder{color:var(--neutral-500);}", ".email-form__input.__jsx-style-dynamic-selector::placeholder{color:var(--neutral-500);}", "@supports (-webkit-touch-callout:none){.email-form__input.__jsx-style-dynamic-selector{font-size:16px;}}", ".email-form__submit-button.__jsx-style-dynamic-selector{display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:3rem;border-radius:2rem;padding:0 1.5rem;-webkit-transition:all 200ms;transition:all 200ms;font-weight:700;-webkit-text-decoration:none;text-decoration:none;text-align:center;white-space:nowrap;cursor:pointer;width:100%;margin-top:0.5rem;}", ".email-form__submit-button[data-focus-visible-added].__jsx-style-dynamic-selector{position:relative;}", ".email-form__submit-button[data-focus-visible-added].__jsx-style-dynamic-selector:after{content:\"\";display:block;position:absolute;top:-6px;right:-6px;bottom:-6px;left:-6px;border:3px solid black;border-radius:10px;}", ".email-form__submit-button.__jsx-style-dynamic-selector .cta-button__arrow.__jsx-style-dynamic-selector,.email-form__submit-button.__jsx-style-dynamic-selector .cta-link__arrow.__jsx-style-dynamic-selector{-webkit-transition:-webkit-transform 320ms;-webkit-transition:transform 320ms;transition:transform 320ms;-webkit-transition-timing-function:cubic-bezier(0.4,0,0.6,2.5);transition-timing-function:cubic-bezier(0.4,0,0.6,2.5);-webkit-transform:translateX(0px);-ms-transform:translateX(0px);transform:translateX(0px);}", ".email-form__submit-button.__jsx-style-dynamic-selector:disabled{opacity:0.5;pointer-events:none;}", ".email-form__submit-button.__jsx-style-dynamic-selector:focus{outline:0;}", ".email-form__submit-button.__jsx-style-dynamic-selector:hover.__jsx-style-dynamic-selector:not([disabled]){-webkit-text-decoration:none;text-decoration:none;}", ".email-form__submit-button.__jsx-style-dynamic-selector:hover.__jsx-style-dynamic-selector:not([disabled]) .cta-button__arrow.__jsx-style-dynamic-selector,.email-form__submit-button.__jsx-style-dynamic-selector:hover.__jsx-style-dynamic-selector:not([disabled]) .cta-link__arrow.__jsx-style-dynamic-selector{-webkit-transform:translateX(4px);-ms-transform:translateX(4px);transform:translateX(4px);}", ".email-form__submit-button--small.__jsx-style-dynamic-selector{height:2.5rem;}", ".email-form__submit-button--wide.__jsx-style-dynamic-selector{width:100%;}", ".email-form__submit-button--slate-fill.__jsx-style-dynamic-selector{background-color:#041527;color:#ffffff;}", ".email-form__submit-button--slate-fill.__jsx-style-dynamic-selector:disabled{opacity:0.5;pointer-events:none;}", ".email-form__submit-button--slate-fill.__jsx-style-dynamic-selector:focus,.email-form__submit-button--slate-fill.__jsx-style-dynamic-selector:hover.__jsx-style-dynamic-selector:not([disabled]){background-color:#223140;color:#ffffff;}", ".email-form__submit-button--slate-fill.__jsx-style-dynamic-selector:active.__jsx-style-dynamic-selector:not([disabled]){-webkit-transform:translateY(4px);-ms-transform:translateY(4px);transform:translateY(4px);}", ".email-form__submit-button--slate-outline.__jsx-style-dynamic-selector{background-color:transparent;box-shadow:inset 0 0 0 2px #041527;color:#041527;}", ".email-form__submit-button--slate-outline.__jsx-style-dynamic-selector:focus,.email-form__submit-button--slate-outline.__jsx-style-dynamic-selector:hover.__jsx-style-dynamic-selector:not([disabled]){box-shadow:inset 0 0 0 3px #223140;color:#041527;}", ".email-form__submit-button--slate-fill-transparent-hover.__jsx-style-dynamic-selector{background-color:#041527;box-shadow:inset 0 0 0 2px #041527;color:#ffffff;}", ".email-form__submit-button--slate-fill-transparent-hover.__jsx-style-dynamic-selector:focus,.email-form__submit-button--slate-fill-transparent-hover.__jsx-style-dynamic-selector:hover.__jsx-style-dynamic-selector:not([disabled]){background-color:transparent;box-shadow:inset 0 0 0 3px black;color:#041527;}", ".email-form__submit-button--slate-fill-transparent-hover.__jsx-style-dynamic-selector .arrow.__jsx-style-dynamic-selector{fill:#ffffff;}", ".email-form__submit-button--slate-fill-transparent-hover.__jsx-style-dynamic-selector:not(:disabled):focus .arrow.__jsx-style-dynamic-selector,.email-form__submit-button--slate-fill-transparent-hover.__jsx-style-dynamic-selector:not(:disabled):hover .arrow.__jsx-style-dynamic-selector{fill:#041527;}", ".email-form__submit-button--slate-fill-transparent-hover__arrow.__jsx-style-dynamic-selector{margin-left:0.625rem;-webkit-transition:-webkit-transform 200ms;-webkit-transition:transform 200ms;transition:transform 200ms;width:1rem;height:auto;}", ".email-form__submit-button--link-only-slate.__jsx-style-dynamic-selector{color:#041527;padding:0;border-radius:0;}", ".email-form__submit-button--blue-fill.__jsx-style-dynamic-selector{background-color:#0057ff;color:#ffffff;}", ".email-form__submit-button--blue-fill.__jsx-style-dynamic-selector:disabled{opacity:0.5;pointer-events:none;}", ".email-form__submit-button--blue-fill.__jsx-style-dynamic-selector:focus,.email-form__submit-button--blue-fill.__jsx-style-dynamic-selector:hover.__jsx-style-dynamic-selector:not([disabled]){background-color:#003db3;color:#ffffff;}", ".email-form__submit-button--blue-fill.__jsx-style-dynamic-selector:active.__jsx-style-dynamic-selector:not([disabled]){-webkit-transform:translateY(4px);-ms-transform:translateY(4px);transform:translateY(4px);}", ".email-form__submit-button--blue-outline.__jsx-style-dynamic-selector{background-color:transparent;box-shadow:inset 0 0 0 2px #0057ff;color:#0057ff;}", ".email-form__submit-button--blue-outline.__jsx-style-dynamic-selector:focus,.email-form__submit-button--blue-outline.__jsx-style-dynamic-selector:hover.__jsx-style-dynamic-selector:not([disabled]){box-shadow:inset 0 0 0 3px #003db3;color:#003db3;}", ".email-form__submit-button--link-only-blue.__jsx-style-dynamic-selector{color:#0057ff;padding:0;border-radius:0;}", ".email-form__submit-button--paper-fill.__jsx-style-dynamic-selector{background-color:#ffffff;color:#0057ff;}", ".email-form__submit-button--paper-fill.__jsx-style-dynamic-selector:disabled{opacity:0.5;pointer-events:none;}", ".email-form__submit-button--paper-fill.__jsx-style-dynamic-selector:focus,.email-form__submit-button--paper-fill.__jsx-style-dynamic-selector:hover.__jsx-style-dynamic-selector:not([disabled]){background-color:#f1f1f1;}", ".email-form__submit-button--paper-fill.__jsx-style-dynamic-selector:active.__jsx-style-dynamic-selector:not([disabled]){-webkit-transform:translateY(4px);-ms-transform:translateY(4px);transform:translateY(4px);}", ".email-form__submit-button--paper-outline.__jsx-style-dynamic-selector{background-color:transparent;box-shadow:inset 0 0 0 2px #ffffff;color:#ffffff;}", ".email-form__submit-button--paper-outline.__jsx-style-dynamic-selector:focus,.email-form__submit-button--paper-outline.__jsx-style-dynamic-selector:hover.__jsx-style-dynamic-selector:not([disabled]){background-color:transparent;box-shadow:inset 0 0 0 3px #f1f1f1;color:#f1f1f1;}", ".email-form__submit-button--link-only-paper.__jsx-style-dynamic-selector{color:#ffffff;padding:0;border-radius:0;}", ".email-form__submit-button--slate-fill.__jsx-style-dynamic-selector:active.__jsx-style-dynamic-selector:not([disabled]),.email-form__submit-button--blue-fill.__jsx-style-dynamic-selector:active.__jsx-style-dynamic-selector:not([disabled]),.email-form__submit-button--paper-fill.__jsx-style-dynamic-selector:active.__jsx-style-dynamic-selector:not([disabled]),.email-form__submit-button--blue-outline.__jsx-style-dynamic-selector:active.__jsx-style-dynamic-selector:not([disabled]),.email-form__submit-button--slate-outline.__jsx-style-dynamic-selector:active.__jsx-style-dynamic-selector:not([disabled]),.email-form__submit-button--paper-outline.__jsx-style-dynamic-selector:active.__jsx-style-dynamic-selector:not([disabled]),.email-form__submit-button--slate-fill-transparent-hover.__jsx-style-dynamic-selector:active.__jsx-style-dynamic-selector:not([disabled]){-webkit-transform:translateY(4px);-ms-transform:translateY(4px);transform:translateY(4px);}", ".email-form__submit-button.__jsx-style-dynamic-selector span{color:inherit;}", ".email-form__submit-button__loading-indicator.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:100%;height:100%;position:absolute;top:0;left:0;border-radius:2rem;background-color:inherit;}", ".email-form__error-message.__jsx-style-dynamic-selector{display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;padding:".concat(size === 'large' ? '0.5rem 1rem' : '0.25rem 0.75rem', ";margin:1rem auto 0;border-radius:2rem;background-color:var(--ui-error);position:relative;text-align:center;}"), ".email-form__error-message.__jsx-style-dynamic-selector span{color:var(--paper);}", ".email-form__error-message.__jsx-style-dynamic-selector:before{position:absolute;display:block;bottom:100%;left:50%;content:\"\";height:10px;width:10px;background-color:var(--ui-error);border-radius:2px;-webkit-transform:translate(-50%,0) rotate(45deg);-ms-transform:translate(-50%,0) rotate(45deg);transform:translate(-50%,0) rotate(45deg);top:-4px;}", ".email-form--loading.__jsx-style-dynamic-selector .email-form__submit__label.__jsx-style-dynamic-selector{opacity:0;}", "@media (".concat(library_utils.mq.tablet, "){.email-form.__jsx-style-dynamic-selector{-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;}.email-form__field.__jsx-style-dynamic-selector{display:grid;grid-template-columns:1fr auto;}.email-form__input.__jsx-style-dynamic-selector{min-width:13rem;border-top-right-radius:0;border-bottom-right-radius:0;}.email-form__submit-button.__jsx-style-dynamic-selector{margin-top:0;border-top-left-radius:0;border-bottom-left-radius:0;}.email-form__error-message.__jsx-style-dynamic-selector{grid-row:2;}}")]
    })]
  });
};
var useEmailValidation = function useEmailValidation(_ref2) {
  var allowPersonalEmails = _ref2.allowPersonalEmails,
      invalidFormatErrorMessage = _ref2.invalidFormatErrorMessage,
      businessEmailErrorMessage = _ref2.businessEmailErrorMessage;

  var _useState = (0,react.useState)(''),
      email = _useState[0],
      setEmail = _useState[1];

  var _useState2 = (0,react.useState)({
    isValid: true
  }),
      validity = _useState2[0],
      setValidity = _useState2[1];

  function validate() {
    return _validate.apply(this, arguments);
  }

  function _validate() {
    _validate = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var gtmClient;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!email || !validEmail/* VALID_EMAIL.test */.I.test(email))) {
                _context.next = 3;
                break;
              }

              setValidity({
                isValid: false,
                errorText: invalidFormatErrorMessage
              });
              return _context.abrupt("return", false);

            case 3:
              _context.next = 5;
              return (0,gtm/* getGtmClient */.n)();

            case 5:
              gtmClient = _context.sent;
              _context.t0 = !allowPersonalEmails;

              if (!_context.t0) {
                _context.next = 11;
                break;
              }

              _context.next = 10;
              return gtmClient.personalEmailDomain(email);

            case 10:
              _context.t0 = _context.sent;

            case 11:
              if (!_context.t0) {
                _context.next = 14;
                break;
              }

              setValidity({
                isValid: false,
                errorText: businessEmailErrorMessage || 'Please enter a business email'
              });
              return _context.abrupt("return", false);

            case 14:
              return _context.abrupt("return", true);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _validate.apply(this, arguments);
  }

  return {
    email: email,
    setEmail: setEmail,
    validate: validate,
    validity: validity
  };
};
;// CONCATENATED MODULE: ./src/mvp/library/elements/EmailForm/index.ts

// EXTERNAL MODULE: ./src/library/hooks/useLocaleCode.ts
var useLocaleCode = __webpack_require__(16387);
// EXTERNAL MODULE: ./src/library/utils/getSignupIntentRedirectPath.ts
var getSignupIntentRedirectPath = __webpack_require__(59695);
;// CONCATENATED MODULE: ./src/mvp/library/elements/SignUpCTA/buttonOnlyCTAContext.tsx

var ButtonOnlyCTAContext = /*#__PURE__*/(0,react.createContext)(false);
/* harmony default export */ var buttonOnlyCTAContext = (ButtonOnlyCTAContext);
// EXTERNAL MODULE: ./src/library/components/MarketoFormV2/index.ts + 2 modules
var MarketoFormV2 = __webpack_require__(86242);
// EXTERNAL MODULE: ./src/library/components/MarketoFormV2/utils/getInitialValues.ts
var getInitialValues = __webpack_require__(12126);
// EXTERNAL MODULE: ./src/library/components/MarketoFormV2/utils/submission.ts
var submission = __webpack_require__(33758);
;// CONCATENATED MODULE: ./src/mvp/library/elements/SignUpCTA/submission.ts



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







function submission_submit(_x) {
  return _submit.apply(this, arguments);
}

function _submit() {
  _submit = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref) {
    var email, marketoForm, isInVbpnp, pricingModelShown, emailSubmissionResult;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            email = _ref.email, marketoForm = _ref.marketoForm, isInVbpnp = _ref.isInVbpnp, pricingModelShown = _ref.pricingModelShown;
            emailSubmissionResult = null;
            _context.prev = 2;
            _context.next = 5;
            return submitMarketoForm(email, marketoForm, isInVbpnp, pricingModelShown);

          case 5:
            emailSubmissionResult = _context.sent;
            _context.next = 8;
            return recordPricingEvent();

          case 8:
            _context.next = 13;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](2);
            (0,sentry.captureException)(new Error("EmailSubmissionError: ".concat(_context.t0)));

          case 13:
            return _context.abrupt("return", emailSubmissionResult);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 10]]);
  }));
  return _submit.apply(this, arguments);
}

function submitMarketoForm(_x2, _x3, _x4, _x5) {
  return _submitMarketoForm.apply(this, arguments);
}

function _submitMarketoForm() {
  _submitMarketoForm = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(email, marketoForm, isInVbpnp, pricingModelShown) {
    var initialValues, _yield$submitMarketoF, emailSubmissionResult;

    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            initialValues = (0,getInitialValues/* default */.Z)(marketoForm.fields);
            _context2.next = 3;
            return (0,submission/* submit */.P)({
              formId: marketoForm.id,
              formFields: _objectSpread(_objectSpread({}, initialValues), {}, {
                Email: email,

                /* eslint-disable @typescript-eslint/naming-convention */
                URL_last__c: "".concat(window.location.origin).concat(window.location.pathname),
                // VBP 1 Feb 2020
                sees_vbp_feb20__c: isInVbpnp,
                // VBP 1.2 Feb 2021, VBP 1.1 Sept 2020
                Pricing_model_shown__c: pricingModelShown
                /* eslint-enable @typescript-eslint/naming-convention */

              }),
              emailSubmissionSource: MarketoFormV2/* SIGNUP_INTENT */.R
            });

          case 3:
            _yield$submitMarketoF = _context2.sent;
            emailSubmissionResult = _yield$submitMarketoF.emailSubmissionResult;
            return _context2.abrupt("return", emailSubmissionResult);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _submitMarketoForm.apply(this, arguments);
}

function recordPricingEvent() {
  return _recordPricingEvent.apply(this, arguments);
}

function _recordPricingEvent() {
  _recordPricingEvent = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
    var gtmClient;
    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return (0,gtm/* getGtmClient */.n)();

          case 2:
            gtmClient = _context3.sent;
            window.Intercom('trackEvent', 'get_started', {
              /* eslint-disable @typescript-eslint/naming-convention */
              action: 'clicked',
              object: 'get_started',
              gtm_tracking_pageview_id: gtmClient.pageviewId || null,
              place: 'pricing_page_top',
              context: 'pricing_page'
              /* eslint-enable @typescript-eslint/naming-convention */

            });

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _recordPricingEvent.apply(this, arguments);
}
;// CONCATENATED MODULE: ./src/mvp/library/elements/SignUpCTA/element.tsx




function element_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function element_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? element_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : element_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


















function SignUpCTA(props) {
  var overrideProps = (0,react.useContext)(SignupCTAOverridePropsContext/* default */.Z);

  var _props$overrideProps = element_objectSpread(element_objectSpread({}, props), overrideProps),
      errorText = _props$overrideProps.errorText,
      buttonLabel = _props$overrideProps.buttonLabel,
      placeholderText = _props$overrideProps.placeholderText,
      small = _props$overrideProps.small,
      forceBusinessEmail = _props$overrideProps.forceBusinessEmail,
      businessEmailErrorMessage = _props$overrideProps.businessEmailErrorMessage,
      pricingTabId = _props$overrideProps.pricingTabId,
      entryDescription = _props$overrideProps.entryDescriptionRequired,
      marketoFormId = _props$overrideProps.marketoFormId,
      showSuccessMessage = _props$overrideProps.showSuccessMessage,
      eventContext = _props$overrideProps.eventContext,
      url = _props$overrideProps.url;

  var _useEmailValidation = useEmailValidation({
    allowPersonalEmails: !forceBusinessEmail,
    invalidFormatErrorMessage: errorText,
    businessEmailErrorMessage: businessEmailErrorMessage
  }),
      email = _useEmailValidation.email,
      setEmail = _useEmailValidation.setEmail,
      validity = _useEmailValidation.validity,
      validate = _useEmailValidation.validate;

  var _useState = (0,react.useState)(false),
      loading = _useState[0],
      setLoading = _useState[1];

  var _useState2 = (0,react.useState)(false),
      success = _useState2[0],
      setSuccess = _useState2[1];

  var isAppPartnerProgram = entryDescription === null || entryDescription === void 0 ? void 0 : entryDescription.includes('App Partner Program - Partner Newsletter');
  var inputRef = (0,react.useRef)(null);
  var router = (0,next_router.useRouter)();
  var signupCTAParams = (0,react.useContext)(SignupCTAParamsContext/* default */.Z);

  var _useContext = (0,react.useContext)(EarlyStage/* EarlyStageContext */.$),
      isEarlyStage = _useContext.isEarlyStage;

  var buttonOnlyCTA = (0,react.useContext)(buttonOnlyCTAContext);
  var localeCode = (0,useLocaleCode/* default */.Z)();
  var marketoForms = (0,MarketoFormsContext/* useMarketoForms */.q)();
  var marketoForm = marketoForms.find(function (f) {
    return f.id === parseInt(marketoFormId);
  });
  var pricingModelShown = 'VBP 2.0';
  var isInVbpnp = false;

  function redirectToPricingOrTalkToSalesOrDemo(_x) {
    return _redirectToPricingOrTalkToSalesOrDemo.apply(this, arguments);
  }

  function _redirectToPricingOrTalkToSalesOrDemo() {
    _redirectToPricingOrTalkToSalesOrDemo = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(emailSubmissionResult) {
      var path;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0,getSignupIntentRedirectPath/* default */.Z)({
                emailSubmissionResult: emailSubmissionResult,
                extraPricingQueryParams: element_objectSpread({
                  tab: pricingTabId
                }, signupCTAParams),
                eventContext: eventContext,
                localeCode: localeCode
              });

            case 2:
              path = _context.sent;
              window.location.assign(path);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _redirectToPricingOrTalkToSalesOrDemo.apply(this, arguments);
  }

  function redirectToSignupFlow(emailSubmissionId) {
    var redirectURL = "".concat(teammateAppUrl/* TEAMMATE_APP_URL */.te, "/a/signup/teams?") + query_string.stringify(element_objectSpread({
      email_submission_id: emailSubmissionId
    }, signupCTAParams));
    window.location.href = redirectURL;
  }

  function onSubmit() {
    return _onSubmit.apply(this, arguments);
  }

  function _onSubmit() {
    _onSubmit = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var isValid, emailSubmission, _emailSubmission;

      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setLoading(true);
              _context2.next = 3;
              return validate();

            case 3:
              isValid = _context2.sent;

              if (isValid) {
                _context2.next = 7;
                break;
              }

              setLoading(false);
              return _context2.abrupt("return");

            case 7:
              if (!email.includes('t2sales')) {
                _context2.next = 10;
                break;
              }

              window.location.href = '/welcome';
              return _context2.abrupt("return");

            case 10:
              emailSubmission = null;

              if (!marketoForm) {
                _context2.next = 17;
                break;
              }

              _context2.next = 14;
              return submission_submit({
                email: email,
                isInVbpnp: isInVbpnp,
                marketoForm: marketoForm,
                pricingModelShown: pricingModelShown
              });

            case 14:
              emailSubmission = _context2.sent;
              _context2.next = 18;
              break;

            case 17:
              (0,sentry.captureException)(new Error("SignupCTA tried to load a non-existent marketo form with id=".concat(marketoFormId)));

            case 18:
              setLoading(false);

              if (url) {
                window.location.href = url;
              } else if (showSuccessMessage || isAppPartnerProgram) {
                setSuccess(true);
              } else if (router.asPath.match('/pricing') || isEarlyStage) {
                redirectToSignupFlow((_emailSubmission = emailSubmission) === null || _emailSubmission === void 0 ? void 0 : _emailSubmission.id);
              } else {
                redirectToPricingOrTalkToSalesOrDemo(emailSubmission);
              }

            case 20:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _onSubmit.apply(this, arguments);
  }

  if (success) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line
      (0,jsx_runtime.jsx)("div", {
        className: "email-form__success-message",
        "data-testid": "success",
        children: "Thanks for signing up! \uD83D\uDC4D"
      })
    );
  }

  if (buttonOnlyCTA) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(CTALink/* CTALink */.U, {
      variant: utils/* CTATheme.SlateFill */.oJ.SlateFill,
      text: buttonLabel,
      url: url || '/pricing',
      small: small
    });
  } else {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(EmailForm, {
      buttonText: buttonLabel,
      inputRef: inputRef,
      loading: loading,
      onChange: setEmail,
      onSubmit: onSubmit,
      placeholderText: placeholderText,
      small: small,
      validity: validity
    });
  }
}
;// CONCATENATED MODULE: ./src/mvp/library/elements/SignUpCTA/index.ts


/***/ }),

/***/ 63769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ CTATheme; }
/* harmony export */ });
var CTATheme;

(function (CTATheme) {
  CTATheme["SlateFill"] = "SlateFill";
  CTATheme["SlateOutline"] = "SlateOutline";
  CTATheme["SlateFillTransparentHover"] = "SlateFillTransparentHover";
  CTATheme["LinkOnlySlate"] = "LinkOnlySlate";
  CTATheme["PaperFill"] = "PaperFill";
  CTATheme["PaperOutline"] = "PaperOutline";
  CTATheme["LinkOnlyPaper"] = "LinkOnlyPaper";
  CTATheme["BlueFill"] = "BlueFill";
  CTATheme["BlueOutline"] = "BlueOutline";
  CTATheme["LinkOnlyBlue"] = "LinkOnlyBlue";
})(CTATheme || (CTATheme = {}));

/***/ }),

/***/ 17849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ContentfulCTALink": function() { return /* binding */ ContentfulCTALink; },
/* harmony export */   "isCTALink": function() { return /* binding */ isCTALink; },
/* harmony export */   "passEventContextToCtaLink": function() { return /* binding */ passEventContextToCtaLink; },
/* harmony export */   "transformCTALink": function() { return /* binding */ transformCTALink; },
/* harmony export */   "transformCTAWithBackground": function() { return /* binding */ transformCTAWithBackground; }
/* harmony export */ });
/* harmony import */ var _tmp_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var marketing_site_src_components_common_EntryMarker__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48304);
/* harmony import */ var marketing_site_src_sass_components_library_elements_CTALink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88511);
/* harmony import */ var marketing_site_src_library_utils_localiseURL__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30985);
/* harmony import */ var _library_utils_constants_CTATheme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63769);
/* harmony import */ var _library_utils_constants_themes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7050);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_tmp_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var ContentfulCTALink = function ContentfulCTALink(ctaLink) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(marketing_site_src_components_common_EntryMarker__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    entry: ctaLink,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(marketing_site_src_sass_components_library_elements_CTALink__WEBPACK_IMPORTED_MODULE_3__/* .CTALink */ .U, _objectSpread({}, transformCTAWithBackground(ctaLink)))
  });
};
function isCTALink(entry) {
  var _entry$sys$contentTyp;

  return ((_entry$sys$contentTyp = entry.sys.contentType) === null || _entry$sys$contentTyp === void 0 ? void 0 : _entry$sys$contentTyp.sys.id) === 'ctaLink';
}
function transformCTALink(_ref) {
  var fields = _ref.fields,
      sys = _ref.sys;
  var _sys$locale = sys.locale,
      locale = _sys$locale === void 0 ? '' : _sys$locale;
  var url = (0,marketing_site_src_library_utils_localiseURL__WEBPACK_IMPORTED_MODULE_7__/* .localiseURL */ .o)(fields.url, locale);
  return _objectSpread(_objectSpread({}, fields), {}, {
    url: url,
    newWindow: fields.openInNewWindow
  });
}
function passEventContextToCtaLink(eventContext, cta) {
  if (eventContext) {
    cta.fields.eventContext = eventContext;
  }
}
function transformCTAWithBackground(_ref2) {
  var fields = _ref2.fields,
      sys = _ref2.sys;
  var text = fields.text,
      variant = fields.variant,
      openInNewWindow = fields.openInNewWindow;
  var _sys$locale2 = sys.locale,
      locale = _sys$locale2 === void 0 ? '' : _sys$locale2;
  var url = (0,marketing_site_src_library_utils_localiseURL__WEBPACK_IMPORTED_MODULE_7__/* .localiseURL */ .o)(fields.url, locale);
  return _objectSpread(_objectSpread({}, fields), {}, {
    url: url,
    text: text,
    variant: variant && (0,_library_utils_constants_themes__WEBPACK_IMPORTED_MODULE_5__/* .getTypedCtaTheme */ .b)(variant) || _library_utils_constants_CTATheme__WEBPACK_IMPORTED_MODULE_4__/* .CTATheme.BlueFill */ .o.BlueFill,
    newWindow: openInNewWindow
  });
}

/***/ }),

/***/ 97760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* reexport */ PreFooterCTABlock; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash.kebabcase/index.js
var lodash_kebabcase = __webpack_require__(35683);
var lodash_kebabcase_default = /*#__PURE__*/__webpack_require__.n(lodash_kebabcase);
// EXTERNAL MODULE: ./src/library/elements/Text/index.ts + 6 modules
var Text = __webpack_require__(36751);
// EXTERNAL MODULE: ./src/mvp/library/elements/RichText/index.ts + 1 modules
var RichText = __webpack_require__(83500);
// EXTERNAL MODULE: ./src/sass-components/library/elements/CTALink/index.ts + 3 modules
var CTALink = __webpack_require__(88511);
// EXTERNAL MODULE: ./src/mvp/library/utils/index.ts
var utils = __webpack_require__(58672);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js
var injectStylesIntoStyleTag = __webpack_require__(93379);
var injectStylesIntoStyleTag_default = /*#__PURE__*/__webpack_require__.n(injectStylesIntoStyleTag);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleDomAPI.js
var styleDomAPI = __webpack_require__(7795);
var styleDomAPI_default = /*#__PURE__*/__webpack_require__.n(styleDomAPI);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertBySelector.js
var insertBySelector = __webpack_require__(90569);
var insertBySelector_default = /*#__PURE__*/__webpack_require__.n(insertBySelector);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js
var setAttributesWithoutAttributes = __webpack_require__(3565);
var setAttributesWithoutAttributes_default = /*#__PURE__*/__webpack_require__.n(setAttributesWithoutAttributes);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertStyleElement.js
var insertStyleElement = __webpack_require__(19216);
var insertStyleElement_default = /*#__PURE__*/__webpack_require__.n(insertStyleElement);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleTagTransform.js
var styleTagTransform = __webpack_require__(44589);
var styleTagTransform_default = /*#__PURE__*/__webpack_require__.n(styleTagTransform);
// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].use[1]!./node_modules/sass-loader/dist/cjs.js!./src/sass-components/library/components/PreFooterCTABlock/styles.module.scss
var styles_module = __webpack_require__(84363);
;// CONCATENATED MODULE: ./src/sass-components/library/components/PreFooterCTABlock/styles.module.scss

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (styleTagTransform_default());
options.setAttributes = (setAttributesWithoutAttributes_default());

      options.insert = insertBySelector_default().bind(null, "head");
    
options.domAPI = (styleDomAPI_default());
options.insertStyleElement = (insertStyleElement_default());

var update = injectStylesIntoStyleTag_default()(styles_module/* default */.Z, options);




       /* harmony default export */ var PreFooterCTABlock_styles_module = (styles_module/* default */.Z && styles_module/* default.locals */.Z.locals ? styles_module/* default.locals */.Z.locals : undefined);

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/sass-components/library/components/PreFooterCTABlock/component.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












var PreFooterCTABlock = function PreFooterCTABlock(_ref) {
  var _classNames, _classNames2;

  var eyebrow = _ref.eyebrow,
      title = _ref.title,
      subhead = _ref.subhead,
      ctas = _ref.ctas,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 'inset' : _ref$width,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? 'transparent' : _ref$backgroundColor,
      checkmarks = _ref.checkmarks,
      linkText = _ref.linkText;
  var classes = classnames_default()(PreFooterCTABlock_styles_module["pre-footer"], 'pre-footer', 'grid-layout', (_classNames = {}, (0,defineProperty/* default */.Z)(_classNames, "mvp-background-color-".concat(lodash_kebabcase_default()(backgroundColor)), backgroundColor), (0,defineProperty/* default */.Z)(_classNames, PreFooterCTABlock_styles_module["pre-footer__inset"], width === 'inset'), (0,defineProperty/* default */.Z)(_classNames, PreFooterCTABlock_styles_module["pre-footer__fullWidth"], width !== 'inset'), _classNames));
  var innerClasses = classnames_default()(PreFooterCTABlock_styles_module["pre-footer__inner"], 'pre-footer__inner');
  var ctaClassNames = classnames_default()(PreFooterCTABlock_styles_module["pre-footer__ctas"], 'pre-footer__ctas', (_classNames2 = {}, (0,defineProperty/* default */.Z)(_classNames2, PreFooterCTABlock_styles_module["pre-footer__ctas__multi-cta-gap"], ctas.length > 1), (0,defineProperty/* default */.Z)(_classNames2, PreFooterCTABlock_styles_module["pre-footer__ctas__single-cta-gap"], ctas.length <= 1), (0,defineProperty/* default */.Z)(_classNames2, PreFooterCTABlock_styles_module["pre-footer__ctas__flex-row"], ctas.length > 1), (0,defineProperty/* default */.Z)(_classNames2, PreFooterCTABlock_styles_module["pre-footer__ctas__flex-column"], ctas.length <= 1), _classNames2));
  var ctaColor = backgroundColor === 'blue' || backgroundColor === 'slate' || backgroundColor === 'deepTeal' ? utils/* CTATheme.LinkOnlyPaper */.oJ.LinkOnlyPaper : utils/* CTATheme.LinkOnlySlate */.oJ.LinkOnlySlate;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classes,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: innerClasses,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: PreFooterCTABlock_styles_module["pre-footer__content"],
          children: [eyebrow && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: PreFooterCTABlock_styles_module["pre-footer__eyebrow"],
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.xv, {
              size: "eyebrow",
              children: eyebrow
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: PreFooterCTABlock_styles_module["pre-footer__title"],
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.xv, {
              size: "heading-3",
              children: title
            })
          }), subhead && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: PreFooterCTABlock_styles_module["pre-footer__subhead"],
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.xv, {
              size: "subhead-sm",
              children: subhead
            })
          }), linkText && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: PreFooterCTABlock_styles_module["pre-footer__link-text"],
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CTALink/* CTALink */.U, _objectSpread(_objectSpread({}, linkText), {}, {
              variant: ctaColor
            }))
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: ctaClassNames,
          children: [!!ctas && ctas, checkmarks && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: PreFooterCTABlock_styles_module["pre-footer__checkmarks"],
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.xv, {
              size: "caption",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(RichText/* RichText */.H, {
                document: checkmarks
              })
            })
          })]
        })]
      })
    })
  });
};
;// CONCATENATED MODULE: ./src/sass-components/library/components/PreFooterCTABlock/index.ts


/***/ })

}]);